import int1 from '../images/integrations-pricing/integration-1.png';
import int2 from '../images/integrations-pricing/integration-2.png';
import int3 from '../images/integrations-pricing/integration-3.png';
import int4 from '../images/integrations-pricing/integration-4.png';
import int5 from '../images/integrations-pricing/integration-5.png';
import int6 from '../images/integrations-pricing/integration-6.png';
import int7 from '../images/integrations-pricing/integration-7.png';
import int8 from '../images/integrations-pricing/integration-8.png';
import int9 from '../images/integrations-pricing/integration-9.png';
import int10 from '../images/integrations-pricing/integration-10.png';
import int11 from '../images/integrations-pricing/integration-11.png';
import int12 from '../images/integrations-pricing/integration-12.png';
import int13 from '../images/integrations-pricing/integration-13.png';
import int14 from '../images/integrations-pricing/integration-14.png';
import int15 from '../images/integrations-pricing/integration-15.png';
import int16 from '../images/integrations-pricing/integration-16.png';
import int17 from '../images/integrations-pricing/integration-17.png';

export type PricingIntegrationIconItem = {src: string; name: string};

/**
 * Match `integrationsList[].name`. Remove a name from this Set to show that
 * icon again on pricing (package rows + legacy pricing cards).
 */
export const PRICING_INTEGRATION_ICON_NAMES_HIDDEN = new Set<string>([
  'Discord',
  'Pabbly Connect',
  'Zapier',
  'KonnectzIT',
  'Make',
  'Integrately',
  'MS Teams',
  'WordPress',
]);

export const integrationsList: PricingIntegrationIconItem[] = [
  {src: int1, name: 'Telegram'},
  {src: int2, name: 'Slack'},
  {src: int3, name: 'Google'},
  {src: int4, name: 'Discord'},
  {src: int5, name: 'Pabbly Connect'},
  {src: int6, name: 'Webhook'},
  {src: int16, name: 'API'},
  {src: int7, name: 'Zapier'},
  {src: int8, name: 'KonnectzIT'},
  {src: int13, name: 'Make'},
  {src: int12, name: 'Integrately'},
  {src: int9, name: 'MS Teams'},
  {src: int10, name: 'WordPress'},
  {src: int17, name: 'SQL Database'},
  {src: int11, name: 'Google Drive'},
  {src: int15, name: 'Google Sheets Import'},
  {src: int14, name: 'Google Sheets (Export/Sync)'},
];

export const integrationsListPricingUi = integrationsList.filter(
  item => !PRICING_INTEGRATION_ICON_NAMES_HIDDEN.has(item.name),
);
